export const meta = "mtdapq0";
export const liveStatus = "l11lkvwn";
export const secondaryAction = "ss33kr7";

// Displays when measurements are being taken for responsive card
export const loading = "l1gqrvdv";
export const title = "t1iah26d";
export const formatLiveTime = "f1520pl1";
export const guideBadgeContainer = "g1mrz6su";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");